import React from "react";
import { useEffect } from "react";
import { Loader } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
// const FaceLivenessDetector = require('../../../../../react-liveness/src/components/FaceLivenessDetector/FaceLivenessDetector');
import FaceLivenessDetector from '../react-liveness/components/FaceLivenessDetector/FaceLivenessDetector';

let isSessionRequested = false;

function b64ToUint8Array(b64Image) {
    var img = atob(b64Image.split(',')[1]);
    var img_buffer = [];
    var i = 0;
    while (i < img.length) {
        img_buffer.push(img.charCodeAt(i));
        i++;
    }
    return new Uint8Array(img_buffer);
}

function FaceLiveness({faceLivenessAnalysis}) {
    const [loading, setLoading] = React.useState(true);
    const [sessionId, setSessionId] = React.useState(null)
    const [appToken, setAppToken] = React.useState(null)
    const [deviceId, setDeviceId] = React.useState(null)
    const [endpoint, setEndpoint] = React.useState(process.env.REACT_APP_ENV_APP_API_URL ? process.env.REACT_APP_ENV_APP_API_URL : '')

    useEffect(() => {
        /*
         * API call to create the Face Liveness Session
         */

        // const fetchCreateLiveness = async () => {
        //     isSessionRequested = true;
        //     const response = await fetch(endpoint + 'createfacelivenesssession');
        //     const data = await response.json();
        //     setSessionId(data.SessionId)
        //     setLoading(false);
        // };

        if(!isSessionRequested) {
            const urlParams = new URLSearchParams(window.location.search);
            const sessionId = urlParams.get('sessionId');
            const appToken = urlParams.get('appToken');
            const deviceId = urlParams.get('deviceId');
            const platform = urlParams.get('platform');

            if(!sessionId || !appToken){
                throw new Error("Must pass session id")
            }

            if(platform && platform === 'web')
                setEndpoint(process.env.REACT_APP_ENV_WEB_API_URL);
            else
                setEndpoint(process.env.REACT_APP_ENV_APP_API_URL);

            if(window['aws_base_url'])
                setEndpoint(window['aws_base_url']);

            console.log('session: ' + sessionId);

            isSessionRequested = true;
            setSessionId(sessionId);
            setAppToken(appToken);
            setDeviceId(deviceId);
            setLoading(false);
        }

    },[])

    /*
   * Get the Face Liveness Session Result
   */
    const handleAnalysisComplete = async (dataURL) => {
        /*
         * API call to get the Face Liveness Session result
         */

        const u8Image  = b64ToUint8Array(dataURL);
        const formData = new FormData();
        formData.append("photo", new Blob([ u8Image ], {type: "image/jpg"}));
        formData.append("device_id", deviceId);

        // const xhr = new XMLHttpRequest();
        // xhr.open("POST", endpoint + "/", true);
        // xhr.send(formData);

        //JSON.stringify({ sessionid: sessionId })
        const response = await fetch(endpoint + '/verification/verify/face?XDEBUG_SESSION_START=PHPSTORM',
            {
                method: 'POST',
                headers: {
                    'Verification-Token': appToken,

                },
                body: formData
            }
        );

        const data = await response.json();
        faceLivenessAnalysis(data.body)
    };

    return (
        <>
            {loading ? (
                <Loader />
            ) : (
                <FaceLivenessDetector
                    sessionId={sessionId}
                    region="eu-west-1"
                    onAnalysisComplete={handleAnalysisComplete}
                    onError={(error) => {
                        console.error(error);
                        console.log(JSON.stringify(error));
                      }}
                />
            )}
        </>
    );
}

export default FaceLiveness;
